




































import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'
import { EditProjectForm } from '@/business/project/components/edit-project/edit-project-form'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { ProjectPartner } from '@/api/generated'
import { updateOrAppend, withoutEntry } from '@/shared/utils/list'
import { imageUrl } from '@/shared/utils/images'
import RespondecoGallery from '@/shared/components/respondeco-gallery.vue'
import RespondecoGalleryItem from '@/shared/components/respondeco-gallery-item.vue'
import RespondecoGalleryAddItem from '@/shared/components/respondeco-gallery-add-item.vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import ResourceItem from '@/business/resource/components/resource-item.vue'
import MiniatureView from '@/shared/components/miniature-view/miniature-view.vue'
import MiniatureItem from '@/shared/components/miniature-view/miniature-item.vue'
import MiniatureItemDescription from '@/shared/components/miniature-view/miniature-item-description.vue'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import AddOrganisationDialog from '@/business/administration/components/add-organisation-dialog.vue'

@Component({
  components: {
    AddOrganisationDialog,
    MiniatureItemDescription,
    MiniatureItem,
    MiniatureView,
    ResourceItem,
    RespondecoToolbarItem,
    RespondecoToolbar,
    RespondecoGalleryAddItem,
    RespondecoGalleryItem,
    RespondecoGallery,
  },
})
export default class EditProjectPartners extends Vue {
  @Prop({
    default: true,
    type: Boolean,
  })
  public readonly editable!: boolean

  @Inject()
  public readonly form!: FormGroup<EditProjectForm>

  public imageUrl = imageUrl

  private dialogService = Injector.get(DialogService)

  get controlValue(): ProjectPartner[] {
    return this.form.field('partners').$model
  }

  set controlValue(partners: ProjectPartner[]) {
    this.form.field('partners').$model = partners
  }

  get length() {
    return this.controlValue?.length ?? 0
  }

  public addPartner(organisation: OrganisationLite) {
    this.controlValue = updateOrAppend(
      this.controlValue,
      {
        organisation,
        testimonial: undefined,
      },
      (a, b) => a.organisation.id === b.organisation.id
    )
  }

  public chooseOrganisation(): void {
    this.dialogService.open('ADD_ORGANISATION_DIALOG')
  }

  public removePartner(partner: ProjectPartner): void {
    this.controlValue = withoutEntry(
      this.controlValue,
      partner,
      (a, b) => a.organisation.id === b.organisation?.id
    )
  }
}
